import { Suspense } from 'react';

import type { NavigationScreenSiteTabCustomization } from '@gitbook/app-navigation';
import { LoadingPanel } from '@gitbook/spine-react';

import { useNavigation } from '../../navigation';
import { useLockSidebar } from '../../state';
import { SiteCustomizationBody } from './SiteCustomizationBody';

/**
 * Screen for the customization of a site.
 */
export function SiteCustomizationScreen(props: {
    screenTab: NavigationScreenSiteTabCustomization;
}) {
    const { screenTab } = props;
    const { navigate } = useNavigation();
    useLockSidebar(true);

    return (
        <Suspense fallback={<LoadingPanel size="large" className="flex-1" />}>
            <SiteCustomizationBody
                selectedTab={screenTab.tab}
                setSelectedTab={(newTab) => {
                    navigate({
                        screen: {
                            tab: {
                                ...screenTab,
                                tab: newTab,
                            },
                        },
                    });
                }}
                siteSpaceId={screenTab.siteSpaceId}
            />
        </Suspense>
    );
}
